import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorsComponent {
  constructor(private router: Router) {}

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  actionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    const { id: VendorId } = rowData;

    if (action === 'view') {
      this.router.navigate(['admin', 'vendor', VendorId, 'info']);
    }
  }
}
